import http from "../../http";

const BASE = "/gateway/syinfopublish/api/pc/information/answer";
const PRIZE_BASE = "/gateway/api/sycomponent/pc/simplePrize";
const WINNER_CALC = "/gateway/api/sycomponent/pc/answerWinner/calculationQuestionWinner";

const informationAnswer = {
  create(param) {
    return http.spin.payload(`${BASE}/createAnswer`, param);
  },
  update(param) {
    return http.spin.payload(`${BASE}/updateAnswer`, param);
  },
  selectQuestionBank(param) {
    return http.get(`${BASE}/selectQuestionBank`, param);
  },
  /** 分页查询答题用户记录（QueryAnswerUserRo：businessCode=informationId） */
  selectAnswerUserPage(param) {
    return http.spin.get(`${BASE}/selectAnswerUserPage`, param);
  },
  /** 导出答题记录（返回下载 URL） */
  exportAnswerUserPage(param) {
    return http.get(`${BASE}/exportAnswerUserPage`, param);
  },
  /** 分页查询答题获奖名单（QueryWinnerPageRo） */
  selectQuestionWinnerPage(param) {
    return http.spin.get(`${BASE}/selectQuestionWinnerPage`, param);
  },
  /** 获奖详情 */
  selectByWinnerId(param) {
    return http.get(`${BASE}/selectByWinnerId`, param);
  },
  /**
   * 活动排行榜（UserRankingVo）
   * 响应：DataValue&lt;UserRankingInfoVo&gt; → res.data.page.dataList / maxCount
   */
  selectAnswerUserRanking(param) {
    return http.spin.get(`${BASE}/selectAnswerUserRanking`, param);
  },
  /**
   * 兑奖（AnswerWinnerRedeemVo，form/urlencoded）
   * fields: winnerUserId, prizeStatus, prizeUser, prizeUserType, staffName, remark
   */
  redeem(param) {
    return http.post(`${BASE}/redeem`, param);
  },
  /** 推送中奖用户（QueryWinnerPageRo：businessType + businessCode） */
  pushByWinner(param) {
    return http.spin.post(`${BASE}/pushByWinner`, param);
  },
  /** 重新生成中奖名单 */
  calculationQuestionWinner(param) {
    return http.spin.post(WINNER_CALC, param);
  },
  /** 抽奖名单分页（simplePrize） */
  selectLuckdrawRecordByPage(param) {
    return http.spin.get(`${PRIZE_BASE}/selectRecordByPage`, param);
  },
  /** 抽奖发放（按兑奖码更新领取状态） */
  updateLuckdrawRecordStatus(param) {
    return http.post(`${PRIZE_BASE}/updateRecordStatus`, param);
  },
};

export default informationAnswer;
